import { render, staticRenderFns } from "./BlogDetailedView.vue?vue&type=template&id=3ba2a7de&scoped=true"
import script from "./BlogDetailedView.vue?vue&type=script&lang=js"
export * from "./BlogDetailedView.vue?vue&type=script&lang=js"
import style0 from "./BlogDetailedView.vue?vue&type=style&index=0&id=3ba2a7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba2a7de",
  null
  
)

export default component.exports